import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import AppRouter from './router';
import { BrowserRouter } from 'react-router-dom';
import { AppThemeProvider } from './context/AppThemeContext';
import { FolderTreeProvider } from './context/FolderTreeContext';

const root = ReactDOM.createRoot(
  document.getElementById('root')!
);
root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <FolderTreeProvider>

        <BrowserRouter basename="/collabora">
          <AppRouter />
        </BrowserRouter>

      </FolderTreeProvider>
    </AppThemeProvider>
  </React.StrictMode>
);

reportWebVitals();